import styled from 'styled-components'

export const Container = styled.div`
 /* background: red; */
 padding: 20px 0px;
 /* margin-bottom: 20px; */
 /* border-bottom: 1px solid #555; */
 text-align: left;
 .header1{
    font-style: normal;
    font-weight: 900;
    font-size: 10px;
    line-height: 1.5;
    /* identical to box height, or 145% */


    color: #8A795D; @media (min-width: 1630px){
   
    @media (min-width: 1630px){
      font-size: 11px;
      
    }
  }
 }
 .header2{

    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 1.2;

    color: #000000;
    small{
        font-weight: 300;
    } 
    @media (min-width: 1630px){
      font-size: 27px;
      
    }
 }
.header-box{
  display: flex;
  width: 100%;
  border-bottom: 1px solid #000;
  
  padding-bottom: 10px;
  margin-bottom:5px;

  .header-box1{
    
    font-size: 20px;
    line-height: 1.2;
    font-weight: 700;
    text-align: left;
    span.small{
      font-weight: 300;
      display: block;
    }

    @media (min-width: 1630px){
      font-size: 27px;
      
    }
  }
  .header-box2{
    text-align: right;
    border-left: 1px solid #000;
    padding-left: 20px;
    margin-left: auto;
  }
  .old-price{

    font-style: normal;
    font-weight: 300;
    font-size: 1em;
    line-height: 1em;
    /* identical to box height, or 100% */

    text-align: right;
    text-decoration-line: line-through;
    padding-bottom: 1em;

    color: #000000;
  }
  .new-price{
    
    font-style: normal;
    font-weight: bold;
    font-weight: bold;
    font-size: 20px;
    line-height: 1;
    /* identical to box height, or 100% */

    text-align: right;

    color: #000000;
    
    @media (min-width: 1630px){
      font-size: 28px;
      
    }
    small{
      font-size: 0.5em;
    }

  }
}

.header-box-description{
    
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: right;

  color: #000000;

}

 p, ul, li{
   font-size: 12px;
 }
 ul{
   list-style:none;
   padding-left: 0;
   margin-left: 0;
 }
 li{
   display: flex;
   &:before{
    content: '•';
    flex-shrink:0;
    flex-grow:0;
    width:10px;
   }
 }

 ul.ul-check > li{
   
  &:before{
    content: '';
    flex-shrink:0;
    flex-grow:0;
    width: 15px;
    /* margin-left: -5px; */
    background: url(${require('../../img/check.svg')}) 0px 4px no-repeat;
    background-size: 13px;
    
   }
 }

`

export const style = {}

export default style
